import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";
import { Colors as ColorsConstant } from "../../../constants/themes/Colors";
import { ColorectalSurgeryPreoperativeForm as ColorectalSurgeryPreoperativeFormConstant } from "../../../constants/Form";
import { DropdownTypes as DropdownTypesConstant } from "../../../constants/Dropdown";
import { InitialDropdown as InitialDropdownConstant } from "../../../constants/Form";
import { GetDropdownByType as GetDropdownByTypeService } from "../../../services/Dropdown";
import { Dropdown as DropdownModel } from "../../../models/Dropdown";
import { useStores } from "../../../stores";
import RadioSelection from "../../inputs/RadioSelection";
import DropdownSelection from "../../dropdowns/Selection";
import InputTextField from "../../inputs/TextField";

interface Props {}

const FormLungMetastasis = observer((props: Props) => {
  const { PreoperativeStore } = useStores();
  const [lungMetastasisOptions, setLungMetastasisOptions] = useState<
    DropdownModel[]
  >([]);

  useEffect(() => {
    !PreoperativeStore.isReadOnly && getDropdownLungMetastasis();
  }, [PreoperativeStore.isReadOnly]);

  const getDropdownLungMetastasis = async () => {
    const response: any = await GetDropdownByTypeService(
      DropdownTypesConstant.preoperativeLungMetastasis
    );
    response.success && setLungMetastasisOptions([...response.data]);
  };
  const onInputChange = (key: string, value: any) => {
    const formObj: any = { ...PreoperativeStore.preoperative };
    const formIsInvalid: any = { ...PreoperativeStore.preoperativeIsInvalid };
    formObj[key] = value;
    formIsInvalid[key] && (formIsInvalid[key] = false);
    if (key === "lungMetastasis" && (!value || value === "false")) {
      formObj.lungMetastasisLabel = { ...InitialDropdownConstant };
      formIsInvalid.lungMetastasisLabel = false;
    }
    PreoperativeStore.onSetPreoperative(formObj);
    PreoperativeStore.onSetPreoperativeIsInvalid(formIsInvalid);
  };
  return (
    <Box id={ColorectalSurgeryPreoperativeFormConstant.lungMetastasis}>
      <Box
        className="input-label"
        color={ColorsConstant.black}
        paddingBottom={1}
        borderBottom="1px solid"
        borderColor={ColorsConstant.border}
      >
        <Typography variant="h6">Lung metastasis</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item marginTop={2} xs={12} md={4}>
          <Box className="input-label">
            <Typography variant="body2">Lung metastasis</Typography>
            <Typography className="input-label-require" variant="body2">
              &nbsp;*
            </Typography>
            <Typography variant="body2">&nbsp;:</Typography>
          </Box>
          <Box display="flex">
            <RadioSelection
              value="true"
              selectedValue={
                PreoperativeStore.preoperative?.lungMetastasis || ""
              }
              label="Yes"
              isDisabled={PreoperativeStore.isReadOnly}
              onChange={(value: any) => onInputChange("lungMetastasis", value)}
            />
            <RadioSelection
              value="false"
              selectedValue={
                PreoperativeStore.preoperative?.lungMetastasis || ""
              }
              label="No"
              isDisabled={PreoperativeStore.isReadOnly}
              onChange={(value: any) => onInputChange("lungMetastasis", value)}
            />
          </Box>
          {PreoperativeStore.preoperativeIsInvalid?.lungMetastasis && (
            <Stack
              className="error-message"
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              marginTop={0.5}
            >
              <ErrorIcon sx={{ fontSize: 16 }} />
              <Typography variant="subtitle2">
                Select a lung metastasis
              </Typography>
            </Stack>
          )}
        </Grid>
        <Grid item marginTop={2} xs={12} md={4}>
          <Box className="input-label">
            <Typography variant="body2">Lung metastasis if yes</Typography>
            <Typography className="input-label-require" variant="body2">
              &nbsp;*
            </Typography>
            <Typography variant="body2">&nbsp;:</Typography>
          </Box>
          <DropdownSelection
            options={lungMetastasisOptions}
            selected={PreoperativeStore.preoperative?.lungMetastasisLabel}
            optionKey="value"
            valueKey="id"
            placeholder="Lung metastasis if yes"
            errorMessage="Lung metastasis if yes is invalid"
            errorIconSize={16}
            isError={
              PreoperativeStore.preoperativeIsInvalid?.lungMetastasisLabel
            }
            isShowErrorMessage={
              PreoperativeStore.preoperativeIsInvalid?.lungMetastasisLabel
            }
            isDisabled={
              PreoperativeStore.isReadOnly ||
              PreoperativeStore.preoperative?.lungMetastasis !== "true"
            }
            isReadOnly={PreoperativeStore.isReadOnly}
            onSelected={(value: any) =>
              onInputChange("lungMetastasisLabel", value)
            }
          />
        </Grid>
        <Grid item marginTop={2} xs={12} md={4}>
          <InputTextField
            id="lungMetastasisDetail"
            label="Lung metastasis detail"
            placeholder="Lung metastasis detail"
            type="text"
            value={String(PreoperativeStore.preoperative.lungMetastasisDetail)}
            isDisabled={PreoperativeStore.isReadOnly}
            isReadOnly={PreoperativeStore.isReadOnly}
            isRequire={false}
            handleOnChange={(value: string) =>
              onInputChange("lungMetastasisDetail", value)
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
});

export default FormLungMetastasis;
